import React from 'react';


// DEFAULT COMPONENT
const UniModalPresentationalBottomSheetKoglovo = (props) => {
  let is_opened = false;
  if (props.opened === true) {
    is_opened = true;
  }
  let clLarge = '';
  if (props.options && props.options.large === true) {
    clLarge = ' unicompo-modal-bottom-sheet-koglovo__modal-wrapper--large';
  }

  let style = { zIndex: 1 }; // default z-index: 1
  if (props.options) {
    const zIndex = props?.options?.zIndex;
    if (zIndex > 0 || zIndex === 0 || zIndex < 0) {
      style.zIndex = zIndex;
    }
  }

  /*
  let cl = "modal-overlay";
  if (modal.animateOut === true) {
    cl += ' animate-close';
  }
  */

  return (
    <div className={"unicompo-modal-bottom-sheet-koglovo" + (is_opened ? " unicompo-modal-bottom-sheet-koglovo--is-opened" : "")} style={style}>
      <div className="unicompo-modal-bottom-sheet-koglovo__overlay unicompo-modal-bottom-sheet-koglovo__overlay--sheet-to-window-enabled">
        <div className={"unicompo-modal-bottom-sheet-koglovo__modal-wrapper" + clLarge}>
          <div className={"unicompo-modal-bottom-sheet-koglovo__card"}>
            <div className="unicompo-modal-bottom-sheet-koglovo__card__pan-header bottom-sheet__pan">
              <div className="unicompo-modal-bottom-sheet-koglovo__card__bar bottom-sheet__bar" onClick={(e) => {
                if (typeof props.cbClose === 'function') {
                  props.cbClose();
                }
              }}></div>
              <div className="unicompo-modal-bottom-sheet-koglovo__close" onClick={(e) => {
                if (typeof props.cbClose === 'function') {
                  props.cbClose();
                }
              }}>&times;</div>
            </div>
            <div className="unicompo-modal-bottom-sheet-koglovo__card__body bottom-sheet__content">        {
              is_opened && (props.children)
            }</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniModalPresentationalBottomSheetKoglovo;